import React from 'react';
import { Menu, MenuLabel, MenuContent, MenuItem, InlineTextButton } from '..';
import classNames from 'classnames';
import { useConfiguration } from '../../context/configurationContext';
import Icons from '../Icons/Icons';
import englishImage from './flags/english.png';
import greekImage from './flags/greek.png';
import germanImage from './flags/german.png';
import css from './LocaleMenu.module.css';
import { switchAppLanguage } from '../../util/genericHelpers';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../../ducks/auth.duck';

const localeOptions = [
  { key: 'el', label: 'Greek', flag: greekImage },
  { key: 'en', label: 'English', flag: englishImage },
  { key: 'de', label: 'German', flag: germanImage },
  // { key: 'ar', label: 'Arabic', flag: null }, // Arabic uses globe icon
];

const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

const LocaleMenu = props => {
  const {
    className,
    rootClassName,
    compact = false,
    isfooterLanguage,
    isOpen = null,
    onToggleActive = null,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const config = useConfiguration();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const location = useLocation();

  if (isAuthenticated) {
    return null;
  }

  const onChangeLocale = (e, locale) => {
    e.preventDefault();
    e.stopPropagation();
    switchAppLanguage({ locale, pathname: location.pathname });
  };

  const locale = localeOptions.find(l => l.key === config.localization.locale);
  const localeLabel = compact ? locale?.key?.toUpperCase() : locale?.label;

  return (
    <Menu className={classes} isOpen={isOpen} onToggleActive={onToggleActive}>
      <MenuLabel className={css.menuLabel}>
        <span className={css.languageSelector}>
          {!compact ? (
            locale?.key === 'ar' ? (
              <span className={css.localeFlag}>
                <Icons name="globeIcon" />
              </span>
            ) : (
              <img className={css.localeFlag} src={locale?.flag} alt={locale?.label} />
            )
          ) : null}
          {(!isMobile || compact) && <span className={css.countryName}>{localeLabel}</span>}
          <svg
            className={css.svgIcon}
            width="17"
            height="10"
            viewBox="0 0 17 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.5 1L8.32927 8L15.5 1" stroke="white" strokeWidth="2" fill="none" />
          </svg>
        </span>
      </MenuLabel>
      <MenuContent className={css.menuContent} arrowPosition={30}>
        {localeOptions.map(l => {
          const menuItemClasses = classNames(css.menuItem, {
            [css.menuItemActive]: locale?.key === l?.key,
          });
          return (
            <MenuItem key={l?.key} className={menuItemClasses}>
              <InlineTextButton
                className={css.menuItemButton}
                type="button"
                onClick={event => onChangeLocale(event, l.key)}
              >
                {!isfooterLanguage ? (
                  l.key === 'ar' ? (
                    <span className={css.flag}>
                      <Icons name="globeIcon" />
                    </span>
                  ) : (
                    <img className={css.flag} src={l?.flag} alt={l?.label} />
                  )
                ) : (
                  ' '
                )}
                <span className={css.label}>{l?.label}</span>
              </InlineTextButton>
            </MenuItem>
          );
        })}
      </MenuContent>
    </Menu>
  );
};

export default LocaleMenu;
